import React from 'react';
import { Navbar, Container, Nav, Button, Badge } from 'react-bootstrap';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { FaUsers, FaUserPlus, FaChartBar, FaSignOutAlt, FaBell, FaRocket, FaFileUpload, FaMoon, FaSun } from 'react-icons/fa';
import { useTheme } from '../../context/ThemeContext';
import { useAuth } from '../../context/AuthContext';
import { useNotifications } from '../../context/NotificationContext';

const AppNavbar = () => {
  const { user, logout } = useAuth();
  const { totalCount } = useNotifications();
  const { darkMode, toggleTheme } = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  
  const handleLogout = () => {
    logout();
    navigate('/login');
  };
  
  // Check if the current path matches the link
  const isActive = (path) => {
    return location.pathname === path;
  };
  
  return (
    <Navbar expand="lg" className="mb-4 py-3 navbar-futuristic">
      <Container>
        <Navbar.Brand as={Link} to="/" className="d-flex align-items-center">
          <div className="brand-icon me-2 d-flex align-items-center justify-content-center">
            <FaRocket />
          </div>
          <span className="brand-text">Client Manager <small className="brand-version">2025</small></span>
        </Navbar.Brand>
        <div className="d-flex align-items-center order-lg-2">
          <div className="me-3">
            <Link to="/notifications" className="notification-bell position-relative d-flex align-items-center">
              <FaBell size={20} className="notification-icon" />
              {totalCount > 0 && (
                <Badge pill bg="danger" className="position-absolute top-0 start-100 translate-middle badge-notification">
                  {totalCount}
                </Badge>
              )}
            </Link>
          </div>
          <div className="me-3">
            <Button 
              variant="link" 
              className="theme-toggle p-0 d-flex align-items-center" 
              onClick={toggleTheme}
              aria-label="Toggle dark mode"
            >
              {darkMode ? (
                <FaSun size={20} className="theme-icon sun" />
              ) : (
                <FaMoon size={20} className="theme-icon moon" />
              )}
            </Button>
          </div>
          {user && (
            <Button 
              variant="primary" 
              size="sm" 
              className="d-flex align-items-center ms-2"
              onClick={handleLogout}
            >
              <FaSignOutAlt className="me-2" /> Logout
            </Button>
          )}
          <Navbar.Toggle aria-controls="basic-navbar-nav" className="ms-2" />
        </div>
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link 
              as={Link} 
              to="/" 
              className={`d-flex align-items-center nav-link-custom ${isActive('/') ? 'active' : ''}`}
            >
              <FaUsers className="me-2" /> Clients
            </Nav.Link>
            <Nav.Link 
              as={Link} 
              to="/add" 
              className={`d-flex align-items-center nav-link-custom ${isActive('/add') ? 'active' : ''}`}
            >
              <FaUserPlus className="me-2" /> Add Client
            </Nav.Link>
            <Nav.Link 
              as={Link} 
              to="/dashboard" 
              className={`d-flex align-items-center nav-link-custom ${isActive('/dashboard') ? 'active' : ''}`}
            >
              <FaChartBar className="me-2" /> Dashboard
            </Nav.Link>
            <Nav.Link 
              as={Link} 
              to="/bulk-upload" 
              className={`d-flex align-items-center nav-link-custom ${isActive('/bulk-upload') ? 'active' : ''}`}
            >
              <FaFileUpload className="me-2" /> Bulk Upload
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default AppNavbar;
